// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M5 21Q4.18 21 3.59 20.41T3 19V5Q3 4.18 3.59 3.59T5 3H11Q11.42 3 11.71 3.29T12 4 11.71 4.71 11 5H5V19H11Q11.42 19 11.71 19.29T12 20 11.71 20.71 11 21ZM17.18 13H10Q9.58 13 9.29 12.71T9 12 9.29 11.29 10 11H17.17L15.3 9.12Q15.02 8.84 15.02 8.44T15.3 7.74 16 7.43 16.72 7.72L20.3 11.3Q20.6 11.6 20.6 12T20.3 12.7L16.72 16.28Q16.42 16.58 16.01 16.57T15.3 16.26Q15.02 15.96 15.04 15.55T15.33 14.86Z"/>';

/** Log Out (account). */
const icon: IconData = {
  id: "logout",
  name: "Log Out",
  category: "account",
  styles: {
    rounded: { svg: m0 },
    sharp: {
      svg: '<path d="M3 21V3H12V5H5V19H12V21ZM16 17L14.62 15.55 17.17 13H9V11H17.18L14.63 8.45 16 7 21 12Z"/>',
    },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M5 21Q4.18 21 3.59 20.41T3 19V5Q3 4.18 3.59 3.59T5 3H11Q11.42 3 11.71 3.29T12 4 11.71 4.71 11 5H5V19H11Q11.42 19 11.71 19.29T12 20 11.71 20.71 11 21ZM17.18 13H10Q9.58 13 9.29 12.71T9 12 9.29 11.29 10 11H17.17L15.3 9.12Q15.02 8.84 15.02 8.44T15.3 7.74 16 7.43 16.72 7.72L20.3 11.3Q20.6 11.6 20.6 12T20.3 12.7L16.72 16.28Q16.42 16.58 16.01 16.57T15.3 16.26Q15.02 15.96 15.04 15.55T15.33 14.86Z"/></g><path d="M5 21Q4.18 21 3.59 20.41T3 19V5Q3 4.18 3.59 3.59T5 3H11Q11.42 3 11.71 3.29T12 4 11.71 4.71 11 5H5V19H11Q11.42 19 11.71 19.29T12 20 11.71 20.71 11 21ZM17.18 13H10Q9.58 13 9.29 12.71T9 12 9.29 11.29 10 11H17.17L15.3 9.12Q15.02 8.84 15.02 8.44T15.3 7.74 16 7.43 16.72 7.72L20.3 11.3Q20.6 11.6 20.6 12T20.3 12.7L16.72 16.28Q16.42 16.58 16.01 16.57T15.3 16.26Q15.02 15.96 15.04 15.55T15.33 14.86Z"/>',
    },
  },
  animation: () => import("../animations/logout.js"),
};

export default icon;
